import { render } from "./SalesPaytsViewerPage.vue?vue&type=template&id=681a6d45&ts=true"
import script from "./SalesPaytsViewerPage.vue?vue&type=script&lang=ts"
export * from "./SalesPaytsViewerPage.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\DDrive\\DeveloperFolder\\VueJsApps\\byihusemanagt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__